export default __webpack_public_path__ + "static/media/BLZD-BUSD.d416f55d.png";